module.exports = __webpack_public_path__ + "static/disclaimer-button-confirm-77831f77e619d52793c3f2930de6d4c1.mp3";